// extracted by mini-css-extract-plugin
export var header = "_xg-1";
export var maskBottom = "_xg-6";
export var maskMiddle = "_xg-7";
export var maskTop = "_xg-5";
export var root = "_xg-0";
export var scrollDownButton = "_xg-3";
export var scrollDownButtonHidden = "_xg-4";
export var viewport = "_xg-2";